<template>
<div class="chapter">
<div class="inner_page">
<p class="p15"><span class="sz"><b>Dedication</b></span></p>
<div style="text-align:center"><img alt="flourish" src="images/flourish.png"/></div>
<p class="p12"><span class="sz">Dedicated to Sheila Johnston Davis who has been my co-conspirator, my confidant, my partner-in-crime, and my closest and dearest friend since Junior High School. Sheila is someone I can count on to always have my back, and to be there for me when I need a true friend. Thank you, Sheila, for being my best friend forever.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section5.vue?545b6e99